import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Animated, Easing, LayoutAnimation, View } from 'react-native';
import { StateConfigContext } from '../../../providers';
import { checkIsPlatform } from '../../../utils';
import { Divider } from '../../divider';
import { getCollapsibleProps, getCollapsibleStyles } from '../CollapsibleStyles';
export var CollapsibleContent = props => {
  var stateContext = useContext(StateConfigContext);
  var collapsibleProps = getCollapsibleProps(props, stateContext);
  var collapseContainerStyles = collapsibleProps.collapseContainerStyles,
    collapseContainerProps = collapsibleProps.collapseContainerProps,
    initialOpen = collapsibleProps.initialOpen,
    isExpanded = collapsibleProps.isExpanded,
    removeOverflow = collapsibleProps.removeOverflow,
    children = collapsibleProps.children,
    contentStyle = collapsibleProps.contentStyle,
    allowAndroidAnimation = collapsibleProps.allowAndroidAnimation,
    showChildTopDividerOnExpand = collapsibleProps.showChildTopDividerOnExpand;
  var heightRef = useRef(new Animated.Value(0));
  var opacityRef = useRef(new Animated.Value(0));
  var _useState = useState(0),
    nativeHeight = _useState[0],
    setNativeHeight = _useState[1];
  var animationRef = useRef(null);
  var _useState2 = useState(0),
    childrenHeight = _useState2[0],
    setChildrenHeight = _useState2[1];
  var collapsibleStyles = getCollapsibleStyles(collapsibleProps, isExpanded);
  var requestAnimationFrameRef = useRef(null);
  var ANIMATION_DURATION = 300;
  var mountRef = useRef(false);
  if (checkIsPlatform('android') && !allowAndroidAnimation) {
    return _jsxs(View, Object.assign({
      style: [contentStyle]
    }, {
      children: [isExpanded && showChildTopDividerOnExpand && _jsx(Divider, {}), _jsx(View, Object.assign({}, collapseContainerProps, {
        style: [collapsibleStyles.contentContainerStyle, !removeOverflow && collapsibleStyles.overflow, collapseContainerStyles, collapseContainerProps === null || collapseContainerProps === void 0 ? void 0 : collapseContainerProps.style]
      }, {
        children: isExpanded && _jsx(View, Object.assign({
          style: [collapsibleStyles.paddingContainer]
        }, {
          children: children
        }))
      }))]
    }));
  }
  useEffect(() => {
    mountRef.current = true;
  }, []);
  useLayoutEffect(() => {
    if (initialOpen || isExpanded) {
      if (checkIsPlatform('web')) {
        heightRef.current.setValue(childrenHeight);
        opacityRef.current.setValue(childrenHeight > 0 ? 1 : 0);
      } else {
        setNativeHeight(childrenHeight);
      }
    }
    return () => {
      var _a, _b, _c, _d, _e;
      if (requestAnimationFrameRef.current) {
        cancelAnimationFrame(requestAnimationFrameRef.current);
      }
      (_a = heightRef.current) === null || _a === void 0 ? void 0 : _a.setValue(0);
      (_b = opacityRef.current) === null || _b === void 0 ? void 0 : _b.setValue(0);
      (_c = animationRef.current) === null || _c === void 0 ? void 0 : _c.stop();
      (_d = heightRef.current) === null || _d === void 0 ? void 0 : _d.stopAnimation();
      (_e = opacityRef.current) === null || _e === void 0 ? void 0 : _e.stopAnimation();
    };
  }, [childrenHeight]);
  var animateOpacity = value => {
    requestAnimationFrame(() => {
      var _a;
      (_a = opacityRef.current) === null || _a === void 0 ? void 0 : _a.stopAnimation();
      Animated.timing(opacityRef.current, {
        useNativeDriver: true,
        toValue: value,
        duration: ANIMATION_DURATION,
        easing: Easing.out(Easing.cubic)
      }).start();
    });
  };
  var animateCollapseForWeb = height => {
    requestAnimationFrameRef.current = requestAnimationFrame(() => {
      var _a;
      (_a = heightRef.current) === null || _a === void 0 ? void 0 : _a.stopAnimation();
      animationRef.current = Animated.timing(heightRef.current, {
        useNativeDriver: false,
        toValue: height,
        duration: ANIMATION_DURATION,
        easing: Easing.out(Easing.cubic)
      }).start();
    });
  };
  var animateCollapseForNative = height => {
    if (mountRef.current) {
      LayoutAnimation.configureNext(Object.assign(Object.assign({}, LayoutAnimation.Presets.easeInEaseOut), {
        duration: ANIMATION_DURATION
      }));
    }
    setNativeHeight(height);
  };
  useLayoutEffect(() => {
    var value = isExpanded ? childrenHeight : 0;
    if (checkIsPlatform('web')) {
      animateCollapseForWeb(value);
    } else {
      animateCollapseForNative(value);
    }
    if (removeOverflow) animateOpacity(isExpanded ? 1 : 0);
  }, [isExpanded]);
  var height = checkIsPlatform('web') ? heightRef.current : nativeHeight;
  return _jsxs(View, Object.assign({
    style: [collapsibleStyles.webContentVisibilityStyle, contentStyle],
    pointerEvents: isExpanded ? 'auto' : 'none'
  }, {
    children: [isExpanded && showChildTopDividerOnExpand && _jsx(Divider, {}), _jsx(Animated.View, Object.assign({}, collapseContainerProps, {
      style: [collapsibleStyles.contentContainerStyle, !removeOverflow && collapsibleStyles.overflow, collapseContainerStyles, collapseContainerProps === null || collapseContainerProps === void 0 ? void 0 : collapseContainerProps.style, Object.assign({
        height
      }, removeOverflow && {
        opacity: opacityRef.current
      })]
    }, {
      children: _jsx(Animated.View, Object.assign({
        style: [collapsibleStyles.paddingContainer, childrenHeight >= 0 && collapsibleStyles.contentContainerBodyStyle],
        onLayout: event => {
          var height = event.nativeEvent.layout.height;
          setChildrenHeight(height);
          if (checkIsPlatform('web') && isExpanded) animateCollapseForWeb(height);
        }
      }, {
        children: children
      }))
    }))]
  }));
};